exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-45[data-v-f749b93c]{margin-top:-45px}.mt-56[data-v-f749b93c]{margin-top:-56px}.title-tournament[data-v-f749b93c]{text-shadow:1px 1px #000;color:#62c6c5}.tag-inscription[data-v-f749b93c]{background-color:#6273b7}.tag-end[data-v-f749b93c]{background-color:red}.tag-completed[data-v-f749b93c]{background-color:#ffc107}", ""]);

// exports
